"use client";

import { c as _c } from "react/compiler-runtime";
import { RegularButton } from "@/components/Button/RegularButton/RegularButton.component";
import { CommentFormSection } from "@/components/Comment/components/form/CommentFormSection.component";
import { CommentsList } from "@/components/Comment/components/list/CommentsList.component";
import { CommentsHeader } from "@/components/Comment/components/section/CommentsHeader.component";
import { CommentsModal } from "@/components/Comment/components/section/CommentsModal.component";
import { useComments } from "@/components/Comment/context/comments.context";
import { useCommentsActions } from "@/components/Comment/hooks/use-comment-actions.hook";
import { Translation } from "@/components/Translation/Translation.component";
export function CommentsSection() {
  const $ = _c(16);
  const {
    state: t0
  } = useComments();
  const {
    totalComments
  } = t0;
  const {
    openModal
  } = useCommentsActions();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CommentsHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Åbn kommentarer (${totalComments})`;
  const t3 = `Kommentare öffnen (${totalComments})`;
  const t4 = `Open comments (${totalComments})`;
  const t5 = `Åpne kommentarer (${totalComments})`;
  const t6 = `Öppna kommentarer (${totalComments})`;
  let t7;
  if ($[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = <Translation da={t2} de={t3} en={t4} no={t5} sv={t6} />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== openModal || $[8] !== t7) {
    t8 = <section aria-label="Comments" className="mx-auto max-w-prose bg-silent p-4">{t1}<RegularButton onClick={openModal} type="button">{t7}</RegularButton></section>;
    $[7] = openModal;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CommentsModal />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8) {
    t10 = <div className="md:hidden">{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <section aria-label="Comments" className="mx-auto hidden max-w-prose bg-silent p-4 md:clear-both md:block"><CommentsHeader /><CommentFormSection /><CommentsList /></section>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10) {
    t12 = <>{t10}{t11}</>;
    $[14] = t10;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  return t12;
}